import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Path } from '@antv/g';
import { Marker } from '@antv/gui';
import { line as d3line } from 'd3-shape';
import { isTranspose } from '../../utils/coordinate';
import { subObject } from '../../utils/helper';
import { select } from '../../utils/selection';
import { applyStyle } from '../utils';
function inferSymbol(x, y, r) {
  return [['M', x, y], ['L', x + 2 * r, y - r], ['L', x + 2 * r, y + r], ['Z']];
}
/**
 * @todo support polar later.
 */
function inferConnectorPath(points) {
  return d3line().x(function (d) {
    return d[0];
  }).y(function (d) {
    return d[1];
  })(points);
}
function getPoints(coordinate, points, offset1, offset2) {
  var length1 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var _points = _slicedToArray(points, 2),
    _points$ = _slicedToArray(_points[0], 2),
    x0 = _points$[0],
    y0 = _points$[1],
    _points$2 = _slicedToArray(_points[1], 2),
    x1 = _points$2[0],
    y1 = _points$2[1];
  if (isTranspose(coordinate)) {
    var X0 = x0 + offset1;
    var X1 = x1 + offset2;
    var X = X0 + length1;
    return [[X0, y0], [X, y0], [X, y1], [X1, y1]];
  }
  var Y0 = y0 - offset1;
  var Y1 = y1 - offset2;
  var Y = Y0 - length1;
  return [[x0, Y0], [x0, Y], [x1, Y], [x1, Y1]];
}
export var Connector = function Connector(options, context) {
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? 0 : _options$offset,
    _options$offset2 = options.offset1,
    offset1 = _options$offset2 === void 0 ? offset : _options$offset2,
    _options$offset3 = options.offset2,
    offset2 = _options$offset3 === void 0 ? offset : _options$offset3,
    length1 = options.connectLength1,
    _options$endMarker = options.endMarker,
    endMarker = _options$endMarker === void 0 ? true : _options$endMarker,
    style = __rest(options, ["offset", "offset1", "offset2", "connectLength1", "endMarker"]);
  var coordinate = context.coordinate;
  return function (points, value, defaults) {
    var defaultColor = defaults.color,
      connectLength1 = defaults.connectLength1,
      rest = __rest(defaults, ["color", "connectLength1"]);
    var color = value.color,
      transform = value.transform;
    var P = getPoints(coordinate, points, offset1, offset2, length1 || connectLength1);
    var makerStyle = subObject(Object.assign(Object.assign({}, style), defaults), 'endMarker');
    return select(new Path()).call(applyStyle, rest).style('path', inferConnectorPath(P)).style('stroke', color || defaultColor).style('transform', transform).style('markerEnd', endMarker ? new Marker({
      className: 'marker',
      style: Object.assign(Object.assign({}, makerStyle), {
        symbol: inferSymbol
      })
    }) : null).call(applyStyle, style).node();
  };
};
Connector.props = {
  defaultMarker: 'line',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};